import { Network } from '@eaphone/network/next.ts';
import type { DeviceStatus } from '@eaphone/types/resources';

export function getStatus({
  serial,
}: {
  serial: string;
}): Promise<DeviceStatus> {
  return Network.custom
    .action(`organization/v1/device/serial/${serial}/status`)
    .then((data) => ({
      ...data,
      heat: data.heat && data.status !== 'Offline',
      volume: data.volume && data.status !== 'Offline',
    }));
}
